import * as THREE from "three";

export default class TextLabel {
  constructor(text, position = { x: 0, y: 0, z: 0 }, className = 'text-label') {
    this.text = text;
    this.position = new THREE.Vector3(position.x, position.y, position.z);
    this.className = className;
    this.domElement = null;
    this.isVisible = true;
    
    this.createDOMElement();
  }

  createDOMElement() {
    this.domElement = document.createElement('div');
    this.domElement.className = this.className;
    this.domElement.textContent = this.text;
    
    // Only apply essential positioning styles - everything else via CSS
    Object.assign(this.domElement.style, {
      position: 'absolute',
      pointerEvents: 'none',
      userSelect: 'none',
      zIndex: '1000',
      transform: 'translate(-50%, -50%)',
      transition: 'opacity 0.3s ease'
    });
    
    // Add to DOM
    document.body.appendChild(this.domElement);
  }

  setPosition(x, y, z) {
    this.position.set(x, y, z);
  }

  setText(newText) {
    this.text = newText;
    if (this.domElement) {
      this.domElement.textContent = newText;
    }
  }

  setClassName(className) {
    this.className = className;
    if (this.domElement) {
      this.domElement.className = className;
    }
  }

  updateScreenPosition(camera, renderer) {
    if (!this.domElement || !this.isVisible) return;

    // Convert 3D position to screen coordinates
    const vector = this.position.clone();
    vector.project(camera);

    // Convert to pixel coordinates
    const widthHalf = renderer.domElement.clientWidth / 2;
    const heightHalf = renderer.domElement.clientHeight / 2;

    const x = (vector.x * widthHalf) + widthHalf;
    const y = -(vector.y * heightHalf) + heightHalf;

    // Check if the object is behind the camera
    const distance = camera.position.distanceTo(this.position);
    const dotProduct = camera.getWorldDirection(new THREE.Vector3()).dot(
      this.position.clone().sub(camera.position).normalize()
    );

    // Hide label if behind camera or too far
    if (dotProduct < 0 || distance > 50) {
      this.domElement.style.opacity = '0';
    } else {
      this.domElement.style.opacity = '1';
      this.domElement.style.left = x + 'px';
      this.domElement.style.top = y + 'px';
    }
  }

  show() {
    this.isVisible = true;
    if (this.domElement) {
      this.domElement.style.display = 'block';
    }
  }

  hide() {
    this.isVisible = false;
    if (this.domElement) {
      this.domElement.style.display = 'none';
    }
  }

  setOpacity(opacity) {
    if (this.domElement) {
      this.domElement.style.opacity = opacity;
    }
  }

  dispose() {
    if (this.domElement && this.domElement.parentNode) {
      this.domElement.parentNode.removeChild(this.domElement);
    }
  }
}
